<div class="flex flex-col gap-[50px] md:gap-[80px] p-4 md:p-8 lg:p-12"
     [class.bg-body-bundle]="isMilano">
  @if (data() && data()?.length || 0 > 0) {
  <section class="flex flex-col gap-3 w-full max-w-8xl">
    <h2 class="flex items-center gap-2">
      <span class="title text-[30px] md:text-[40px]"
            [class.text-primary]="isMilano"
            [class.text-dark]="!isMilano">Nos</span>
      <span class="title text-[30px] md:text-[40px]"
            [class.text-white]="isMilano"
            [class.text-dark]="!isMilano">Menus</span>
    </h2>

    <div class="relative" style="isolation: isolate;">
      @if (canScrollLeft) {
  <button
    (click)="scrollLeft()"
    class="nav-arrow left-arrow absolute left-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer border border-gray-100">
    <mat-icon class="text-dark">chevron_left</mat-icon>
  </button>
  }

  <div #scrollContainer class="scroll-container flex gap-6 overflow-x-auto scrollbar-hide snap-x">
    @for (card of data(); track card; let i = $index) {

  @if (isMilano) {
  <div class="bundle-item-wrapper w-[295px] flex-shrink-0 snap-center mb-4 rounded-[8px] overflow-hidden bg-cover bg-center text-white relative flex flex-col h-[400px]"
       [style.background-image]="'url(' + getBackgroundImage(i) + ')'"
       [class.is-disabled]="!card._isAvailable">
    @if (!card._isAvailable) {
  <div class="absolute inset-0 backdrop-blur-[1px] bg-white/10 z-30 rounded-[8px] pointer-events-none"></div>
  }
  @if (card._availabilityLabel) {
  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
              bg-[#ffffffb8] text-badge text-[#000000] font-bold px-3 py-2 rounded-xl shadow-md uppercase
               text-center custom-phone-badge border border-gray-300">
    {{ card._availabilityLabel }}
  </div>
  }
  <div class="relative z-10 flex flex-col items-center justify-between h-full p-4 pb-5">
    <div class="pt-1">
     <img
  ngSrc="/assets/images/good-food-logo.webp"
  alt="Good Food"
  width="144"
  height="56"
  loading="lazy"
  sizes="10vw"
  class="w-36 drop-shadow-md" />
    </div>
    <div class="relative flex justify-center mt-4 w-full max-w-[180px] h-[160px]">
          <img
      [ngSrc]="card.image || 'assets/images/placeholders/placeholder.webp'"
      [alt]="card.name || 'Image à venir'"
      fill
      loading="lazy"
   sizes="(max-width: 640px) 50vw,
       (max-width: 1024px) 33vw,
       22vw"
      class="object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-xl" />
    </div>
    <div class="text-center mt-2">
      <h3 class="text-[22px] font-bold uppercase tracking-wider drop-shadow-lg"
          [style.color]="getColorText(i)"
          style="font-family: 'Pattaya', cursive;">
  {{ card.name }}
  </h3>
</div>
<div class="mt-4 w-full">
  <a [href]="'/menus/' + card.slug"
     [ngClass]="getButtonClass(i)"
     class="w-44 px-4 py-3 rounded-lg font-bold text-sm tracking-wider flex items-center justify-between gap-2 mx-auto cursor-pointer text-white shadow-md"
     (click)="$event.preventDefault(); openDialogBundle(card)">
    <span>Commander</span>
    <mat-icon class="text-lg">shopping_cart</mat-icon>
  </a>
</div>
</div>
</div>
  }

  @else {
  <div class="bundle-item-wrapper w-[280px] flex-shrink-0 snap-center mb-4 cursor-pointer"
       (click)="$event.preventDefault(); openDialogBundle(card)">
    <div class="custom-bundle-card relative rounded-2xl overflow-hidden border border-gray-100 bg-white shadow-sm flex flex-col h-full"
         [class.is-disabled]="!card._isAvailable">
      @if (!card._isAvailable) {
  <div class="absolute inset-0 backdrop-blur-[1px] bg-white/40 z-30 rounded-2xl pointer-events-none"></div>
  }

  @if (card._availabilityLabel) {
  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40
              bg-[#ffffffb8] text-badge text-[#000000] font-bold px-3 py-2 rounded-xl shadow-md uppercase
               text-center custom-phone-badge border border-gray-300">
    {{ card._availabilityLabel }}
  </div>
  }
  <div class="relative w-full bg-transparent flex items-center justify-center p-6 h-[278px]">
    <img
      [ngSrc]="card.image || 'assets/images/placeholders/placeholder.webp'"
      [alt]="card.name || 'Image à venir'"
      fill
      loading="lazy"
   sizes="(max-width: 640px) 50vw,
       (max-width: 1024px) 33vw,
       22vw"
      class="object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-xl" />
  </div>
  <div class="p-4 flex justify-between items-end bundle-text-section flex-grow">
    <div class="flex-1 min-w-0">
      <h3 class="bundle-title text-[22px] text-dark font-primary leading-tight mb-1">
  {{ card.name }}
  </h3>
</div>
<a [href]="'/menus/' + card.slug"
   class="bundle-cart-btn w-12 h-12 bg-primary text-white flex justify-center items-center rounded-xl hover:scale-110 transition-all cursor-pointer shadow-lg"
   (click)="$event.preventDefault(); openDialogBundle(card)">
  <mat-icon class="text-[22px]">shopping_cart</mat-icon>
</a>
</div>
</div>
</div>
  }

  }
  </div>

  @if (canScrollRight) {
  <button
    (click)="scrollRight()"
    class="nav-arrow right-arrow absolute right-2 top-1/2 -translate-y-1/2 z-40 w-9 h-9 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer border border-gray-100">
    <mat-icon class="text-dark">chevron_right</mat-icon>
  </button>
  }
  </div>
</section>
  }

  @if (isMilano) {
  <div class="w-full max-w-8xl bg-cover bg-no-repeat bg-cover bg-center rounded-lg p-4 md:p-6"
       style="background-image: url('/assets/images/background-menu.webp')">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center max-w-5xl mx-auto">

      <div class="flex justify-center order-1 md:order-2">
        <img
          ngSrc="assets/images/tacos.webp"
          alt="Tacos"
          width="400"
          height="320"
          loading="lazy"
          sizes="(max-width: 768px) 60vw, 25vw"
          class="h-[280px] md:h-[320px] object-contain drop-shadow-2xl" />
      </div>

      <div class="flex flex-col items-center md:items-start text-center md:text-left space-y-4 order-2 md:order-1">

        <h2 class="text-primary title text-[28px] md:text-[36px] leading-tight">
          TACOS : Composez à votre goût
        </h2>

        <div class="space-y-3 text-sm md:text-base flex flex-col justify-center">
          <div class="flex flex-col">
            <div class="flex items-start gap-2 m-0">
              <span class="text-primary font-bold">01.</span>
              <span class="text-base-content font-medium title">Choisir la taille</span>
            </div>
            <p class="text-base-content title">Petit, moyen ou XXL — à vous de doser l'appétit !</p>
          </div>

          <div class="flex flex-col">
            <div class="flex items-start gap-2 m-0">
              <span class="text-primary font-bold">02.</span>
              <span class="text-base-content font-medium title">Choisir la viande</span>
            </div>
            <p class="text-base-content title">Poulet, bœuf, merguez, tenders... il y en a pour tous les goûts.</p>
          </div>

          <div class="flex flex-col">
            <div class="flex items-start gap-2 m-0">
              <span class="text-primary font-bold">03.</span>
              <span class="text-base-content font-medium title">Choisir le gratinage</span>
            </div>
            <p class="text-base-content title">Avec ou sans fromage gratiné ? C'est vous le chef !</p>
          </div>

          <div class="flex flex-col">
            <div class="flex items-start gap-2 m-0">
              <span class="text-primary font-bold">04.</span>
              <span class="text-base-content font-medium title">Penser à nos suppléments</span>
            </div>
            <p class="text-base-content title">Frites, sauces, boissons… ajoutez la touche finale à votre menu.</p>
          </div>

          <a href="/product"
             class="mt-4 w-full md:w-[160px] flex items-center justify-between gap-2 px-2 py-3
                    bg-primary hover:bg-primary/60 text-white rounded-md transition-all text-sm font-medium cursor-pointer"
             (click)="$event.preventDefault(); navigateToCategory()">
            <span>Commander</span>
            <mat-icon class="text-[16px]">shopping_cart</mat-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
  }

</div>
